import PropTypes from "prop-types";
import FieldLabel from "@shared/v2/FieldLabel";
import TextInput from "@shared/v2/TextInput";
import CollapsibleWebsiteCard from "../shared/CollapsibleWebsiteCard";

const DetailsPanel = ({ data = undefined, setDetailsData }) => {
  return (
    <CollapsibleWebsiteCard title="Details">
      <div className="tw-flex tw-flex-col tw-gap-[24px]">
        <TextInput
          autoComplete="off"
          label="Page Title"
          placeholder="Enter a title for your page"
          isRequired
          helperText={`${(data?.name || "").length} / 256 characters`}
          value={data?.name || ""}
          onChange={(e) =>
            setDetailsData({
              ...data,
              name: e.target.value,
            })
          }
        />

        <div className="tw-flex tw-flex-col tw-gap-[4px]">
          <FieldLabel label="Area" />
          <div>
            {data?.variables?.vars?.find((variable) => variable.key === "location")?.value || "Custom"}
          </div>
        </div>
      </div>
    </CollapsibleWebsiteCard>
  );
};

DetailsPanel.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
    variables: PropTypes.shape({
      vars: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string, value: PropTypes.string })),
    }),
  }),
  setDetailsData: PropTypes.func.isRequired,
};

export default DetailsPanel;
